import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { PenSquare, Save } from "lucide-react";

export const EditNews = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const adminEmail = "cyprien.conseillon@icloud.com";

  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    const fetchNews = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || user.email !== adminEmail) {
        navigate("/");
        return;
      }
      setAuthorized(true);

      const { data, error } = await supabase
        .from("news")
        .select("*")
        .eq("id", id)
        .single();

      if (error || !data) {
        alert("News introuvable.");
        navigate("/news");
        return;
      }

      setTitle(data.title);
      setContent(data.content);
      setLoading(false);
    };
    fetchNews();
  }, [id, navigate]);

  const handleUpdate = async () => {
    if (!title.trim() || !content.trim()) {
      alert("Titre et contenu requis.");
      return;
    }
    setSaving(true);
    const { error } = await supabase
      .from("news")
      .update({ title: title.trim(), content: content.trim() })
      .eq("id", id);
    setSaving(false);

    if (error) {
      console.error(error);
      alert("Erreur lors de la mise à jour.");
    } else {
      alert("Article mis à jour !");
      navigate("/news");
    }
  };

  if (!authorized || loading) {
    return <p className="text-center mt-10 text-gray-600 dark:text-gray-300">Chargement...</p>;
  }

  return (
    <section className="min-h-screen w-full p-6 mx-auto bg-gray-50 text-gray-900 dark:bg-gray-950 dark:text-gray-100">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold mb-6 text-center text-orange-600 dark:text-orange-400 flex items-center justify-center gap-2">
          <PenSquare className="w-6 h-6" />
          Modifier une actu
        </h1>

        <div className="rounded-2xl border bg-white border-gray-200 shadow-sm p-6 dark:bg-gray-900 dark:border-gray-800">
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1 text-gray-800 dark:text-gray-200">
              Titre
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Titre"
              className="w-full rounded px-3 py-2 border
                         bg-white border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-orange-400/60
                         dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-1 text-gray-800 dark:text-gray-200">
              Contenu
            </label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={8}
              placeholder="Contenu"
              className="w-full rounded px-3 py-2 border
                         bg-white border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-orange-400/60
                         dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
            />
          </div>

          <button
            onClick={handleUpdate}
            disabled={saving || !title.trim() || !content.trim()}
            className={`w-full inline-flex items-center justify-center gap-2 font-semibold py-2 px-6 rounded transition
                        focus:outline-none focus:ring-2 focus:ring-orange-400/60
                        ${saving || !title.trim() || !content.trim()
                          ? "bg-orange-300 cursor-not-allowed text-white"
                          : "bg-[#fc7825] hover:bg-orange-600 text-white"}`}
          >
            <Save className="w-4 h-4" />
            {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
        </div>
      </div>
    </section>
  );
};
